module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_7042.80244432.png";